import React from 'react';
import styled from 'styled-components';

import { ResourceVisibility } from '@/store/enums';

type MappedVisibilityType = 'PUBLISHED' | 'UNPUBLISHED' | 'EXPIRED';

interface IProps {
  visibility?: ResourceVisibility;
}

const visibilityMapping: { [key in ResourceVisibility]: MappedVisibilityType } = {
  [ResourceVisibility.unpublished]: 'UNPUBLISHED',
  [ResourceVisibility.published]: 'PUBLISHED',
  [ResourceVisibility.expired]: 'EXPIRED',
};

const VisibilityChip = ({ visibility }: IProps): React.ReactElement => {
  if (visibility === undefined) {
    return <></>;
  }

  const variant = visibilityMapping[visibility];

  return (
    <Container>
      <Chip variant={variant}>{variant}</Chip>
    </Container>
  );
};

export { VisibilityChip };

const Container = styled.div`
  color: #fff;
  text-overflow: ellipsis;
  overflow: hidden;
  border-radius: 8px;
`;

const Chip = styled.span<{ variant: MappedVisibilityType }>`
  color: #fff;
  font-size: 14px;
  padding: 2px 8px;
  border-radius: 8px;

  background-color: ${({ variant }) => {
    switch (variant) {
      case 'PUBLISHED':
        return '#28a745';
      case 'UNPUBLISHED':
        return '#eb0000';
      default:
        return '#6c757d';
    }
  }};
`;
